var i = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var g = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var e = (r, o, t) => o in r ? i(r, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[o] = t, n = (r, o) => {
  for (var t in o || (o = {}))
    g.call(o, t) && e(r, t, o[t]);
  if (a)
    for (var t of a(o))
      p.call(o, t) && e(r, t, o[t]);
  return r;
}, m = (r, o) => c(r, f(o));
import s, { forwardRef as d } from "react";
import l from "../lib/IconBase.mjs";
import w from "../defs/WarningOctagon.mjs";
const O = d((r, o) => /* @__PURE__ */ s.createElement(l, m(n({ ref: o }, r), { weights: w })));
O.displayName = "WarningOctagon";
export {
  O as WarningOctagon
};
